import { usePermission } from '@/contexts/permission/usePermission';
import type { MenuList } from '@/types/menu.type';

export const usePerm = () => {
  const { hasPermission } = usePermission();
  return {
    can: (key: string) => hasPermission(key),
  };
};

export const convertPermissions = (menuList: MenuList) => {
  const permissionMap = new Map<string, string[]>();

  const traverseMenu = (menus: MenuList) => {
    menus.forEach((menu) => {
      if (menu.path) {
        permissionMap.set(menu.path, menu.permissions || []);
      }
      if (menu.children && menu.children.length > 0) {
        traverseMenu(menu.children);
      }
    });
  };

  traverseMenu(menuList);
  return permissionMap;
};
